import React from 'react';
import styled, { css } from 'styled-components';
import { cssColorValue, spacer16, spacer40, spacer48, screenXxsMax, screenSmMax, screenMdMin, spacer24, } from '@spotify-internal/encore-web';
export const MAX_CONTENT_WIDTH = '1520px';
export const MAX_CONTENT_SCREEN_WIDTH = `calc(${MAX_CONTENT_WIDTH} + 48px + 48px)`;
export const TWO_COLUMN_MAX_WIDTH = screenSmMax;
export const ONE_COLUMN_MAX_WIDTH = screenXxsMax;
export const MD_GRID_MAX_WIDTH = '1439px';
const GridLayout = styled.div `
  color: ${cssColorValue('textBase')};
  background-color: ${cssColorValue('backgroundBase')};
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: ${spacer24};

  ${({ fullBleed }) => !fullBleed &&
    css `
      padding-inline: ${spacer48};

      @media (min-width: ${MAX_CONTENT_WIDTH}) {
        padding-left: ${spacer48};
        padding-right: ${spacer48};
      }

      @media (min-width: ${MAX_CONTENT_SCREEN_WIDTH}) {
        // add calculated padding to keep the content at 1520px
        // as soon as the screen width is wider than 1520px + the relevant padding
        padding-inline: calc((100% - ${MAX_CONTENT_WIDTH}) / 2);
      }

      @media (min-width: ${screenMdMin}) and (max-width: ${MD_GRID_MAX_WIDTH}) {
        padding-left: ${spacer40};
        padding-right: ${spacer40};
        padding-inline: ${spacer40};
      }

      @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
        padding-inline: ${spacer40};
      }

      @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
        padding-inline: ${spacer16};
      }
    `}

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: unset;
  }

  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    grid-template-columns: 100%;
    grid-template-rows: unset;
  }
`;
export const Grid = React.forwardRef(({ children, className = '', fullBleed = false }, ref) => {
    return (React.createElement(GridLayout, { ref: ref, className: className, fullBleed: fullBleed }, children));
});
